import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import { getRentalTypeBadges, RentalTypeBadges } from '../../components/features/listings/RentalTypeBadges';
import { getTrustSignalDisplay, TrustSignal } from '../../components/features/listings/TrustSignal';
import * as styles from './haloListingPage.styles';

// Skip the wrapper entirely when neither child has content. The wrapper's
// margins and the `[data-summary-row] + [data-module-list]` padding-collapse
// rule (haloListingPage.styles.tsx) would otherwise apply on listings with
// neither badges nor history data, leaving an empty 16px gap and crushing
// the next module's top padding.
//
// Reads `currentListing` once and memoizes both child computations, then
// passes results down so children skip their own selectors and recomputation.
export const SummaryRow = () => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const badges = useMemo(() => getRentalTypeBadges(listing), [listing]);
  const display = useMemo(() => getTrustSignalDisplay(listing?.history), [listing]);
  if (badges.length === 0 && !display.showListed && !display.showUpdated) return null;

  // `data-summary-row` is a CSS hook for `summaryRow`'s sibling-padding
  // collapse onto the next module — see haloListingPage.styles.tsx.
  return (
    <div data-summary-row="" className={styles.summaryRow}>
      <RentalTypeBadges badges={badges} />
      <TrustSignal display={display} />
    </div>
  );
};
